import { createContext } from 'react';

export interface LayoutContextProps {
  language: {
    i18nKey: string;
    langPrefix: string;
    shortLangPrefix: string;
    urlLangPrefix: string;
  };
  location: {
    pathname: string;
  };
  pageType: string;
  abTesting: {
    updateTest: (config: {}) => void;
  };
}

const defaultContext: LayoutContextProps = {
  language: {
    langPrefix: 'en',
    shortLangPrefix: 'en',
    urlLangPrefix: '',
    i18nKey: 'en'
  },
  location: {
    pathname: ''
  },
  pageType: '',
  abTesting: {
    updateTest: () => undefined
  }
};

export default createContext(defaultContext);
